import { ChevronLeft } from '../icons.js';

import { ProgressCount } from './ProgressCount.js';

import type { ProjectSummary } from './projects.js';

/**
 * Список проектов с прогрессом по каждому (3.8.7).
 *
 * Отдельного экрана «создать проект» здесь нет и быть не может: проект — это
 * обычная задача, у которой появились вложенные (3.8.1). Поэтому список
 * пустой ровно до тех пор, пока ни у одной задачи не выбран проект, и пустое
 * состояние объясняет, как проект заводится, а не предлагает кнопку «создать».
 */
export function ProjectList({
  projects,
  onOpen,
  onBack,
  backLabel,
}: {
  projects: readonly ProjectSummary[];
  onOpen: (projectId: string) => void;
  onBack: () => void;
  backLabel: string;
}): React.ReactElement {
  return (
    <section className="screen">
      <header className="screen__head">
        {/*
          Имя начинается с «Назад», а видимая подпись входит в него целиком:
          иначе в озвучке это просто «Сентябрь, кнопка» — слово, которое ничего
          не обещает. Требование «видимый текст — часть имени» при этом
          соблюдено.
        */}
        <button type="button" className="link" aria-label={`Назад: ${backLabel}`} onClick={onBack}>
          <ChevronLeft />
          {backLabel}
        </button>
        <h1>Проекты</h1>
        <p className="head__sub">задачи, в которые вложены другие</p>
      </header>

      {projects.length === 0 ? (
        <div className="empty">
          <p>Проектов пока нет.</p>
          <p>
            Проект — обычная задача, у которой появились вложенные: откройте любую задачу и выберите
            ей проект в строке «Проект».
          </p>
        </div>
      ) : (
        <ul className="list__rows">
          {projects.map(({ task, progress }) => (
            <li key={task.id} className={`row row--${task.status}`}>
              <span className="row__body">
                <button type="button" className="row__title" onClick={() => onOpen(task.id)}>
                  {task.title}
                </button>
                <span className="row__marks">
                  <ProgressCount progress={progress} />
                  {progress.done === progress.total && <span className="tag">всё закрыто</span>}
                </span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
